// @flow

import type { GroupedOptionType } from '../../../components/types'

type State = {|
  options: Array<GroupedOptionType>,
  ids: Array<number>,
  errors: Array<string>
|}

type PutAction = {|
  +type: 'AUD_SELECT.PUT',
  +state: $Shape<State>
|}

type PatchAction = {|
  +type: 'AUD_SELECT.PATCH',
  +state: $Shape<State>
|}

type Action = PutAction | PatchAction

export type { State }

const initialState: State = {
  options: [],
  ids: [],
  errors: []
}

export function put(state: State): PutAction {
  return {
    type: 'AUD_SELECT.PUT',
    state: state
  }
}

export function patch(diff: $Shape<State>): PatchAction {
  return {
    type: 'AUD_SELECT.PATCH',
    state: diff
  }
}

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'AUD_SELECT.PUT':
      return action.state
    case 'AUD_SELECT.PATCH':
      return { ...state, ...action.state }
    default:
      return state
  }
}
